export const itemsOnPageDefault = 10;
const itemsOnPageOptions = [itemsOnPageDefault, 25, 50, 100];

export let listWithSearchAndPaginationMixin = {
  props: {
    query: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      itemsOnPage: this.query.itemsOnPage ? parseInt(this.query.itemsOnPage) : itemsOnPageDefault,
      itemsOnPageOptions: itemsOnPageOptions,
      pageNumber: this.query.pageNumber ? parseInt(this.query.pageNumber) : 1,
      search: this.query.search ? this.query.search.toString() : null,

      queryStringKeysToCheck: ['search', 'pageNumber', 'itemsOnPage'],

      useMountedFromMixin: true,
      // Component that uses this mixin must return `functionToCallOnChange` and `listPathName`.
      // E.g.
      // functionToCallOnChange: this.loadVouchersPaginated,
      // listPathName: 'voucher-list',
    }
  },
  computed: {
    /**
     * Prepare params that will be used as a query string for API calls.
     *
     * If this method overridden in a component, `queryStringKeysToCheck`
     * in `data` must be overridden as well.
     *
     * @returns {Object}
     */
    loadingParams() {
      return {
        itemsOnPage: this.itemsOnPage,
        pageNumber: this.pageNumber,
        search: this.search,
      }
    },
    /**
     * Prepare params that will be used/shown as a query string in
     * browser's address bar.
     *
     * @returns {Object}
     */
    queryParams() {
      let params = {};
      this.queryStringKeysToCheck.forEach((key) => {
        if (this[key]) {
          params[key] = this[key];
        }
      });
      return params;
    },
  },
  mounted() {
    if (this.useMountedFromMixin) {
      this.loadList();
    }
  },
  methods: {
    loadList() {
      // `replace` in this case will update a query string in browser's address bar.
      // `catch` needed here to remove "NavigationDuplicated" error from console.
      // Please see: https://github.com/vuejs/vue-router/issues/2872
      this.$router.replace({ name: this.listPathName, query: this.queryParams }).catch((error) => {});

      // Update component's data respectively to the query string.
      this.functionToCallOnChange(this.loadingParams);
    },
    onSearchTermChange(searchTerm) {
      // Avoid searching on short search terms
      if (searchTerm.length && searchTerm.length < 3) return;

      // If `searchTerm == ''` (empty string) it is better to set it to `null`.
      // In this case in URL's query string we will not have "search=".
      const newSearchTerm = searchTerm.trim() || null;
      if (this.search !== newSearchTerm) {
        this.search = newSearchTerm;
        // Start from the 1st page on each search term change.
        this.pageNumber = 1;
        this.loadList();
      }
    },
    onPageNumberChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.loadList();
    },
    goToDetailPage(pageName, itemID) {
      this.$router.push({ name: pageName, params: { id: itemID } });
    },
    onItemsOnPageChange(itemsOnPageNew) {
      this.itemsOnPage = itemsOnPageNew;
      // Start from the 1st page on each change.
      this.pageNumber = 1;
      this.loadList();
    },
  }
};



// WEBPACK FOOTER //
// ./src/services/mixins.js